import { useAppointmentProposalShare } from '@airship-platform/airship-patterns';
import {
  EmptyState,
  LoadingButton,
} from '@airship-platform/jam-web/components';
import { Link, useNavigate } from 'react-router';
import { useAppointmentProposals } from '../../../data-access/appointmentProposals';
import { SectionWrapper } from '../../../patterns';
import SendSurveySection from './sections/SendSurveySection';
import { SendSurveyFormInputs } from './send-survey-section/SendSurveyForm';

const FORM_ID = 'proposalSendSurveyForm';

const SendSurveyPage: React.FC = () => {
  const navigate = useNavigate();
  const { currentProposal, isLoading, updateAppointmentProposal } =
    useAppointmentProposals();
  const { isLoading: isLoadingShare } = useAppointmentProposalShare();

  if (!currentProposal) {
    return (
      <EmptyState
        title="Appointment not found"
        subtitle="Oops! The requested appointment was not found."
      />
    );
  }

  const onSubmit = (data: SendSurveyFormInputs) =>
    updateAppointmentProposal(
      currentProposal.appointmentId,
      currentProposal.appointmentProposalId,
      { surveyContacts: data.surveyContacts }
    ).then(() => navigate(-1));

  return (
    <SectionWrapper
      maxWidth={'28rem'}
      width={'100%'}
      header="Share the customer survey"
      subheader="Your customer will enter some personal details about their income, household size, and tax filing. After submitting, we'll display their eligible tax incentives on systems and equipment."
      actionsButtons={{
        left: {
          color: 'softGold',
          component: Link,
          to: '../',
          label: 'Cancel',
        },
        right: {
          type: 'submit',
          component: LoadingButton,
          form: FORM_ID,
          label: 'Send',
          loading: isLoading || isLoadingShare,
          disabled: isLoading || isLoadingShare,
        },
      }}
    >
      <SendSurveySection
        formId={FORM_ID}
        defaultValues={{
          surveyContacts: currentProposal.surveyContacts,
          customContact: '',
        }}
        onSubmit={onSubmit}
      />
    </SectionWrapper>
  );
};

export default SendSurveyPage;
